const CustomizeModel = require("../appModel/Customize/CustomizeModel")
class CustomizeUtil {

  // カスタマイズレコード住ゴム
  static customizeSumigomu = "sumigomu";

  /**
   * カスタマイズレコードを取得する
   * @param {*} tenantId　テナントID
   * @returns カスタマイズレコードのkey
   */
  static async checkCustomizeRecords(tenantId) {
    // カスタマイズレコードを取得する
    let customizeRecords = await CustomizeModel.getCustomize(tenantId);
    console.log(`カスタマイズレコード：${JSON.stringify(customizeRecords)}`);

    let customize = {
      key: "",
      maxItem: 10,
      maxuser: 20
    };

    // カスタマイズレコードが存在する場合
    if (customizeRecords != null) {
      customize.key = customizeRecords.customize.key;
      customize = this.setTenantSpecificValues(customize)
    } else {
    // 存在しない場合
      customize.key = "";
    }
    return customize;
  }

  static async setTenantSpecificValues(customize) {
    switch (customize.key) {
      case CustomizeUtil.customizeSumigomu:
        customize.maxItem = 30
        customize.maxuser = 50
        break;
      default:
        break;
    }

    return customize;
  }
}

module.exports = CustomizeUtil;
